/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Dispatch, SetStateAction } from 'react';
import { Button, Header, Heading } from 'grommet';

const TeamsPageHeader: React.FC<{ setIsCreateModalOpen: Dispatch<SetStateAction<boolean>> }> = ({
  setIsCreateModalOpen,
}) => (
  <Header align="center" border="bottom" flex={{ grow: 0, shrink: 0 }} justify="between" pad="40px">
    <Heading color="night90" level="2" size="small">
      Teams
    </Heading>
    <Button id="it-open-create-team-modal" label="Create new team" onClick={() => setIsCreateModalOpen(true)} primary />
  </Header>
);

export default TeamsPageHeader;
